import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { sessionManager } from '../utils/sessionManager';

interface SessionExpirationHandlerProps {
  children: React.ReactNode;
}

const SessionExpirationHandler: React.FC<SessionExpirationHandlerProps> = ({
  children,
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Create session expiration handler
    const handler = {
      onSessionExpired: () => {
        navigate('/login', { replace: true });
      },
    };

    // Register the handler
    sessionManager.registerSessionExpirationHandler(handler);

    // Cleanup on unmount
    return () => {
      sessionManager.unregisterSessionExpirationHandler(handler);
    };
  }, [navigate]);

  return <>{children}</>;
};

export default SessionExpirationHandler;
